import type { CollectionEntityDefinition } from '@gzl10/nexus-sdk'
import { useIdField, useTextField, useSelectField, useDatetimeField } from '@gzl10/nexus-sdk/fields'

export const tagAssignmentsEntity: CollectionEntityDefinition = {
  type: 'collection',
  table: 'tag_assignments',
  expose: false,
  label: { en: 'Tag Assignment', es: 'Asignación de etiqueta' },
  labelPlural: { en: 'Tag Assignments', es: 'Asignaciones de etiquetas' },
  labelField: 'entity_type',
  timestamps: false,

  fields: {
    id: useIdField(),
    tag_id: useSelectField({
      label: { en: 'Tag', es: 'Etiqueta' },
      table: 'tags',
      endpoint: '/taxonomy/tags',
      onDelete: 'CASCADE',
      required: true,
      index: true
    }),
    entity_type: useTextField({
      label: { en: 'Entity Type', es: 'Tipo de entidad' },
      required: true,
      size: 100,
      index: true
    }),
    entity_id: useTextField({
      label: { en: 'Entity ID', es: 'ID de entidad' },
      required: true,
      size: 26,
      index: true
    }),
    created_at: useDatetimeField({
      label: { en: 'Created At', es: 'Creado el' }
    })
  },

  indexes: [
    { columns: ['tag_id', 'entity_type', 'entity_id'], unique: true },
    { columns: ['entity_type', 'entity_id'] }
  ],

  casl: {
    subject: 'TaxonomyTagAssignment',
    permissions: {
      EDITOR: { actions: ['manage'] },
      USER: { actions: ['create', 'read'] },
      VIEWER: { actions: ['read'] }
    }
  }
}
